import { render, staticRenderFns } from "./ProjectTeam.vue?vue&type=template&id=2a017558"
import script from "./ProjectTeam.vue?vue&type=script&lang=ts"
export * from "./ProjectTeam.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports